import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import PageBanner from '@/components/feature/PageBanner';
import SubmitForm from './components/SubmitForm';

const checklist = [
  '线索的大致时间与地点是否已经写清',
  '是否有可佐证的公开链接、截图或照片来源',
  '内容是否涉及与线索无关的第三人隐私',
  '是否愿意留下一个可回信的邮箱地址',
];

const bcrumb = [
  { label: '首页', to: '/' },
  { label: '投稿入口' },
];

const pageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '17吃瓜网投稿入口',
  url: 'https://gzruanke.cn/submit',
  inLanguage: 'zh-CN',
  description: '17吃瓜网投稿入口，支持匿名投稿、署名投稿与私信爆料，填写线索标题与详情即可递到编辑手里。',
  isPartOf: { '@type': 'WebSite', name: '17吃瓜网', url: 'https://gzruanke.cn/' },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://gzruanke.cn/' },
      { '@type': 'ListItem', position: 2, name: '投稿入口', item: 'https://gzruanke.cn/submit' },
    ],
  },
};

export default function SubmitPage() {
  return (
    <SiteLayout>
      <title>投稿入口 - 17吃瓜网匿名投稿与私信爆料通道</title>
      <meta
        name="description"
        content="进入17吃瓜网投稿入口，填写线索标题与详情即可完成匿名投稿。支持署名投稿与私信爆料，投稿人身份仅编辑可见，提交后36小时内初步核实。"
      />
      <meta name="keywords" content="17吃瓜网投稿入口,匿名投稿,私信爆料,线索征集,爆料联系方式" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://gzruanke.cn/submit" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="17吃瓜网" />
      <meta property="og:title" content="投稿入口 - 17吃瓜网匿名投稿与私信爆料通道" />
      <meta property="og:description" content="填写线索标题与详情即可完成投稿，支持匿名与署名，投稿人身份仅编辑可见。" />
      <meta property="og:url" content="https://gzruanke.cn/submit" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="投稿入口 - 17吃瓜网匿名投稿与私信爆料通道" />
      <meta name="twitter:description" content="填写线索标题与详情即可完成投稿，支持匿名与署名投稿。" />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }} />

      <PageBanner
        eyebrow="爆料线索 · 直接递到编辑"
        title="投稿入口"
        description="这里是17吃瓜网唯一的正式线索征集入口。填好下面的表单，你的线索会直接进入编辑线索库，按方向分派给对应编辑进行核实。"
        breadcrumb={bcrumb}
      />

      <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
        <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-8">
            <SubmitForm />
          </div>

          <aside className="lg:col-span-4 flex flex-col gap-5">
            <div className="p-6 rounded-lg bg-secondary-100 border border-secondary-200">
              <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-checkbox-multiple-line text-xl text-secondary-700"></i>
                投稿前请确认
              </h2>
              <ul className="mt-4 flex flex-col gap-3">
                {checklist.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm leading-6 text-foreground-700">
                    <i className="ri-check-line text-lg text-secondary-700 mt-0.5 shrink-0"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="p-6 rounded-lg bg-background-100 border border-background-200">
              <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-chat-private-line text-xl text-primary-600"></i>
                不想填表？走私信爆料
              </h2>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                如果你更习惯直接对话，也可以通过下面两个渠道把线索发给我们，编辑会手动录入线索库。
              </p>
              <ul className="mt-4 flex flex-col gap-3">
                <li className="flex items-center gap-3 text-sm text-foreground-800">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className="ri-mail-line"></i>
                  </span>
                  tougao@17chigua.example
                </li>
                <li className="flex items-center gap-3 text-sm text-foreground-800">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className="ri-message-3-line"></i>
                  </span>
                  站内私信：@17吃瓜网编辑
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-lg bg-accent-100 border border-accent-200">
              <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-compass-3-line text-xl text-accent-700"></i>
                不确定投哪一类
              </h2>
              <p className="mt-3 text-sm leading-7 text-foreground-700">
                先看看我们正在征集的方向，把线索和方向对上，采用概率会更高。
              </p>
              <Link
                to="/#categories"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-accent-800 hover:text-accent-900 transition-colors cursor-pointer"
              >
                查看线索征集范围
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="p-6 rounded-lg bg-background-100 border border-background-200">
              <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-book-open-line text-xl text-foreground-500"></i>
                投稿前必读
              </h2>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                关于匿名投稿如何保护身份、材料需要达到什么标准，完整说明都写在投稿指南里。
              </p>
              <Link
                to="/guide"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                阅读投稿指南
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </aside>
        </div>
      </section>
    </SiteLayout>
  );
}